
import React  from "react";
import './SellerSection.css';
import { Container , Col , Row } from "reactstrap";
import { SELLER__DATA } from "../../../assets/data/data";



function  SellerSection ()  {

    console.log();
    
    return (
        <section  className="">
            <Container>
                <Row>
                    <Col  lg='12'  className="mb-5">
                        <div className="seller__section-title">
                            <h3> Top Seller  </h3>
                        </div>
                    </Col>

                    {
                        SELLER__DATA.map((item) => {
                            console.log(item);

                            return (
                                <Col  lg="2" md="3"  sm="4" xs='6' key={item.id}  className="mb-4" >
                                    <div  className="single__seller-card   d-flex   align-items-center  gap-3" >
                                        <div className="seller__img">
                                            <img  src={item.sellerImg}  className="w-100" />
                                        </div>

                                        <div  className="seller__content">
                                            <h6> {item.sellerName} </h6>
                                            <h6> {item.currentBid} </h6>
                                        </div>
                                    </div>
                                    
                                </Col>
                            );
                            
                        })
                    }

                </Row>
            </Container>
        </section>
    );
}

export default  SellerSection;

